import { RetailerKpiOption, SaleType } from '@models/Products';
import { Kpi } from '@utils/Formatters';

/**
 *
 * @param selectedLineChartSaleType - Show dropdown in Product Compare Line Chart. e.g. Revenue, Units. Price
 * @param selectedRetailerOption - "and" dropdown in Product Compare Line Chart. e.g.Absolute, Retailer Share, Retailer Mix.
 * Price case will always return retailer price for Retailer Line chart, y-axis and plotted lines.
 * Revenue will return either retailer revenue, or retailer share revenue/mix.
 * Units will return either retailer volume, or retailer share volume for retailer share and mix.
 */
export const getSaleTypeRetailerShareKpi = (
  selectedLineChartSaleType: SaleType,
  selectedRetailerOption: RetailerKpiOption,
): Kpi => {
  switch (selectedLineChartSaleType) {
    case SaleType.revenue:
      return selectedRetailerOption === RetailerKpiOption.absolute ? Kpi.retailerRevenue : Kpi.retailerShareRevenue;
    case SaleType.volume:
      return selectedRetailerOption === RetailerKpiOption.absolute ? Kpi.retailerVolume : Kpi.retailerShareVolume;
    case SaleType.price:
    default:
      return Kpi.retailerPrice;
  }
};
